import React from 'react';
import PropTypes from "prop-types";
import LazyMetrics from '@/pages/dashboard-year/LazyMetrics';
import {useTranslation} from "react-i18next";
import EvalProjectEducatorResponses from "./EvalProjectEducatorResponses";
import EvalProjectPartnerResponses from "./EvalProjectPartnerResponses";
import EvalEventEducatorResponses from "./EvalEventEducatorResponses";
import EvalEventPartnerResponses from "./EvalEventPartnerResponses";

EvalAllResponses.propTypes = {
  network: PropTypes.object,
  schoolStart: PropTypes.string,
  schoolEnd: PropTypes.string,
};
export default function EvalAllResponses({network, schoolStart, schoolEnd, ...rest}) {
  const {t} = useTranslation();

  return (<>
      {/*Evaluation Responses*/}
      <LazyMetrics
        title={t(`dashboard.evaluations.title.evaluationProjectEducator`)}
        columns={1}
      >
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <EvalProjectEducatorResponses {...rest} network={network} schoolStart={schoolStart} schoolEnd={schoolEnd} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title={t(`dashboard.evaluations.title.evaluationProjectPartner`)}
        columns={1}
      >
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <EvalProjectPartnerResponses {...rest} network={network} schoolStart={schoolStart} schoolEnd={schoolEnd} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title={t(`dashboard.evaluations.title.evaluationEventEducator`)}
        columns={1}
      >
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <EvalEventEducatorResponses {...rest} network={network} schoolStart={schoolStart} schoolEnd={schoolEnd} />
        </div>
      </LazyMetrics>
      <LazyMetrics
        title={t(`dashboard.evaluations.title.evaluationEventPartner`)}
        columns={1}
      >
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          <EvalEventPartnerResponses {...rest} network={network} schoolStart={schoolStart} schoolEnd={schoolEnd} />
        </div>
      </LazyMetrics>
    </>);
}
